import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from '../core/guards/admin.guard';
import { admin_nav_path } from './views/admin/admin.module';
import { newStory_nav_path } from './views/new-story/new-story.module';
import { AuthGuard } from '../core/guards/auth.guard';
import { privateStories_nav_path } from './views/stories/stories.module';
import { LayoutComponent } from '../shared/components/layout/layout.component';
import { profile_nav_path } from './views/profile/profile.module';

const COMPONENTS = []!;

export const private_nav_path = {
  admin: '/admin', ...admin_nav_path,
  newStory: '/new-story', ...newStory_nav_path,
  privateStories: '/me', ...privateStories_nav_path,
  profile: '/profile', ...profile_nav_path
};

const routes: Routes = [
  { path: 'admin', loadChildren: () => import('./views/admin/admin.module')
      .then(m => m.AdminModule), canActivate: [AdminGuard] },
  { path: 'new-story', loadChildren: () => import('../private/views/new-story/new-story.module')
      .then(m => m.NewStoryModule), canActivate: [AuthGuard] },
  { path: '', component: LayoutComponent, children: [
      { path: 'me', loadChildren: () => import('./views/stories/stories.module')
          .then(m => m.PrivateStoriesModule), canActivate: [AuthGuard] },
      { path: 'profile', loadChildren: () => import('./views/profile/profile.module')
          .then(m => m.ProfileModule), canActivate: [AuthGuard] }
    ] },
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrivateModule { }
